<template>
  <div class="footer">
    <!-- <a href=""></a> -->
    <router-link class="link" to="/detail/about">ABOUT US</router-link>
    <router-link class="link" to="/detail/contact">CONTACT US</router-link>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  height: .8rem;
  padding: 0 .4rem;
  .link{
    line-height: .8rem;
    width: 20%;
    font-size: .16rem;
    text-transform: uppercase;
    flex: 1;
    max-width: 2rem;
    cursor: pointer;
    text-decoration: none;
    color: #333;
  }
}
</style>
